import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_28_1 implements Validator {

    public static id = 'CTRL_28_1';
    private message = 'error.ctr_28';


    public LOG: LogService = new LogService(CTRL_28_1);
    public formExtractorService: FormExtractorService = new FormExtractorService();


    validate(form: any, map) {


        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_28_1.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const critere = ctrl.value.rgCtrls.critere;
                const criterePoids = ctrl.value.rgCtrls.criterePoids;
                const critereLibreNameWithStepId = map.get(ctrl.value.rgCtrls.critereLibre);
                const critereLibreCtrl = form.controls[critereLibreNameWithStepId];

                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                const criterePondereIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_CriterePondere'], '_index_');
                if (critereLibreCtrl === undefined) {
                    if (criterePondereIters.size < 2 ) {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    } else {
                        let nbCriterePondere = 0;
                        for (let i = 1; i <= criterePondereIters.size; i++) {
                            const critereCtrl = form.controls[map.get(critere.replace('INDEX_28_1', i))];
                            const criterePoidsCtrl = form.controls[map.get(criterePoids.replace('INDEX_28_1', i))];
                            if (critereCtrl.value !== '' && criterePoidsCtrl.value !== '') {
                                nbCriterePondere++;
                            }
                        }
                        if (nbCriterePondere > 1) {
                            form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                        } else {
                            // placer le message d'erreur
                            form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                        }
                    }
                } else {
                    if (criterePondereIters.size < 1 && critereLibreCtrl.value.length < 1) {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    } else {
                        let nbCriterePondere = 0;
                        for (let i = 1; i <= criterePondereIters.size; i++) {
                            const critereCtrl = form.controls[map.get(critere.replace('INDEX_28_1', i))];
                            const criterePoidsCtrl = form.controls[map.get(criterePoids.replace('INDEX_28_1', i))];
                            if ((critereCtrl.value !== '' && critereCtrl.value !== null) &&
                                (criterePoidsCtrl.value !== '' && criterePoidsCtrl.value !== null)) {
                                nbCriterePondere++;
                            }
                        }
                        if (nbCriterePondere > 1 || (nbCriterePondere > 0 && critereLibreCtrl.value.length > 0)) {
                            form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                        } else {
                            // placer le message d'erreur
                            form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                        }
                    }
                }
            }
        }
    }
}
